export function deletePercent(val){
    if(!val) return
    return val.substring(1,val.length-1)
}

export function addPercent(val){
    return '%'+val+'%'
}